import { render, staticRenderFns } from "./AvailableUnits.vue?vue&type=template&id=073aae1a"
import script from "./AvailableUnits.vue?vue&type=script&lang=js"
export * from "./AvailableUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073aae1a')) {
      api.createRecord('073aae1a', component.options)
    } else {
      api.reload('073aae1a', component.options)
    }
    module.hot.accept("./AvailableUnits.vue?vue&type=template&id=073aae1a", function () {
      api.rerender('073aae1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/AvailableUnits.vue"
export default component.exports